import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ShopSettingsService } from "../../general/services/shop-settings.service";
import { VuPaymentType } from "../../payment/models/vu-payment-type.enum";
import { VuConfiguration as VuConfiguration } from "../models/vu-configuration";
import { VuConnectionHttpService } from "./vu-connection-http.service";

@Injectable()
export class VuConfigurationService {
  constructor(
    private shopSettingsService: ShopSettingsService,
    private vuConnectionHttpService: VuConnectionHttpService,
  ) {
  }

  get isAvailable(): boolean {
    return this.shopSettingsService?.isVUMode ?? false;
  }

  get vuConfiguration(): Observable<VuConfiguration> {
    return this.vuConnectionHttpService.getVuConfiguration();
  }

  get vuPaymentMethods(): Observable<VuPaymentType[]> {
    return this.vuConfiguration
      .pipe(
        map(configuration => configuration?.vuPaymentMethods ?? []),
      );
  }
}
